import { useEffect, useState } from 'react';
import CookieConsent, { getCookieConsentValue } from 'react-cookie-consent';
import { Link } from './core';
import { RulesModal } from './RulesModal';

const GA_ID = 'G-BG7V85TRPN';

export function GDPRAConsentModal() {
  const [isRulesModalOpen, setIsRulesModalOpen] = useState(false);
  useEffect(() => {
    const consent = getCookieConsentValue('analytics_consent');

    if (consent === 'true') {
      loadGA();
    }
  }, []);

  function loadGA() {
    if (window.gtag) return;

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', GA_ID, { anonymize_ip: true });
  }

  function handleAccept() {
    loadGA();
    setIsRulesModalOpen(true);
  }

  function handleDecline() {
    setIsRulesModalOpen(true);
  }

  function handleRulesModalClose() {
    setIsRulesModalOpen(false);
  }

  return (
    <>
      <CookieConsent
        location="bottom"
        buttonText="Accept analytics"
        declineButtonText="Decline"
        enableDeclineButton
        cookieName="analytics_consent"
        onAccept={handleAccept}
        onDecline={handleDecline}
        style={{
          background: '#2B373B',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        overlay
        overlayStyle={{ background: '#121212DD' }}
        contentStyle={{
          flex: 'none',
        }}
        buttonStyle={{
          background: '#aaa',
          color: '#000',
          fontSize: '13px',
        }}
        declineButtonStyle={{
          background: '#4e503b',
          color: '#fff',
          fontSize: '13px',
        }}
      >
        We use Google Analytics to collect data. We need this data to understand
        how you use our website so we can improve its design and functionality.
        With your consent, Google Analytics will process and collect your
        personal data (cookies and IP address) to give us valuable information.
        Google Analytics will transfer your data to the United States and store
        it for 6 months. To learn more about Google's data transfer policies,{' '}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.google.com/policies/privacy/partners/"
        >
          click here
        </Link>
        . You have certain rights over your data: for example, you can require
        us to delete them or to provide you with a copy. We take responsibility
        for the processing of your data. We are available to answer any question
        and handle any request from you. Go to the "Give us feedback" link in
        the footer of the site if you have any queries, concerns or requests.
      </CookieConsent>

      <RulesModal onClose={handleRulesModalClose} isOpen={isRulesModalOpen} />
    </>
  );
}
